import { useEffect, useState } from "react";

// Loads the Facebook JS SDK once and initialises it for the given app id.
// Returns { ready, error }. Safe to call from several components.
export function useFacebookSdk(appId, version = "v21.0") {
  const [ready, setReady] = useState(() => typeof window !== "undefined" && !!window.FB && window.__fbInitAppId === appId);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!appId || typeof window === "undefined") return;
    if (window.FB && window.__fbInitAppId === appId) { setReady(true); return; }

    const init = () => {
      try {
        window.FB.init({ appId, autoLogAppEvents: true, xfbml: false, version });
        window.__fbInitAppId = appId;
        setReady(true);
      } catch (e) { setError(e); }
    };

    if (window.FB) { init(); return; }
    const prev = window.fbAsyncInit;
    window.fbAsyncInit = () => { if (typeof prev === "function") prev(); init(); };

    if (!document.getElementById("facebook-jssdk")) {
      const s = document.createElement("script");
      s.id = "facebook-jssdk";
      s.src = "https://connect.facebook.net/en_US/sdk.js";
      s.async = true; s.defer = true; s.crossOrigin = "anonymous";
      s.onerror = () => setError(new Error("Could not load the Facebook SDK (blocked by an ad-blocker or network?)"));
      document.body.appendChild(s);
    }
  }, [appId, version]);

  return { ready, error };
}
